import { createOidcAuth, LogLevel, SignInType } from 'vue-oidc-client/vue3'

let mainOidc = null

if (window.auth) {

    if (process.env.VUE_APP_SSO_URL != undefined) {
        window.auth.authority = process.env.VUE_APP_SSO_URL;
        window.auth.response_type = "code";
        window.auth.loadUserInfo = true;
        window.auth.metadata = {
            issuer: `${process.env.VUE_APP_SSO_URL}/realms/upc`,
            authorization_endpoint: `${process.env.VUE_APP_SSO_URL}/realms/upc/protocol/openid-connect/auth`,
            token_endpoint: `${process.env.VUE_APP_SSO_URL}/realms/upc/protocol/openid-connect/token`,
            userinfo_endpoint:
                `${process.env.VUE_APP_SSO_URL}/realms/upc/protocol/openid-connect/userinfo`,
            jwks_uri: `${process.env.VUE_APP_SSO_URL}/realms/upc/protocol/openid-connect/certs`,
            end_session_endpoint: `${process.env.VUE_APP_SSO_URL}/realms/upc/protocol/openid-connect/logout`,
        };
    }
    if (process.env.VUE_APP_SSO_CLIENT_ID != undefined) {
        window.auth.client_id = process.env.VUE_APP_SSO_CLIENT_ID;
        window.auth.scope = `openid profile email`;
    }

    const loco = window.location
    const appRootUrl = `${loco.protocol}//${loco.host}${process.env.BASE_URL}`;
    mainOidc = createOidcAuth(
        'main',
        SignInType.Window,
        appRootUrl,
        window.auth,
        console,
        LogLevel.Error
    )
}

export default mainOidc
